module.exports = __webpack_public_path__ + "static/media/IMG_9074.9a550fb7.png";